import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Plataformas de Petróleo/Petroleo.jpg';
import imagem2 from '../assets/images/Projetos/Plataformas de Petróleo/plataforma-img2.jpg';
import imagem3 from '../assets/images/Projetos/Plataformas de Petróleo/plataforma-img3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Plataformas de Petróleo",
    images: [
     imagem1,
     imagem2,
     imagem3
    ],
    description:
    "Para diversas Plataformas de Petróleo fornecemos a seguinte solução:",
    solutions: ["Coberturas WI-FI"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;